import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import BasisTableComponent from "../table/BasisTableComponent";

const Programs = () => {
  const [programs, setPrograms] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, pages: 1 });
  const [loading, setLoading] = useState(true);
  const [noResults, setNoResults] = useState(false);

  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();
  const nameQuery = query.get("name");

  const fetchPrograms = async (page = 1) => {
    setLoading(true);
    setNoResults(false);

    try {
      let apiUrl = `https://plo.areez.co/api/programs?page=${page}&per_page=5`;
      if (nameQuery) { apiUrl  =`https://plo.areez.co/api/plo/programs/summary?page=${page}&per_page=5&name=${encodeURIComponent(nameQuery)}`};
      

      console.log(apiUrl);
      const res = await fetch(apiUrl);
      if (!res.ok) throw new Error("فشل في جلب البيانات");

      const result = await res.json();
      const data = result.data || [];

      setPagination({
        page: result.pagination?.page || 1,
        pages: result.pagination?.pages || 1,
      });

      setPrograms(data);
      setNoResults(data.length === 0);
    } catch (err) {
      console.error("خطأ:", err);
      setPrograms([]);
      setNoResults(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPrograms(1);
  }, [nameQuery]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= pagination.pages) {
      fetchPrograms(newPage);
    }
  };

  const columns = nameQuery
    ? [
      { label: "#", field: "program_id" },
        { label: "الكود", field: "program_code" },
        { label: "اسم الجامعة", field: "company_name" },
        { label: "الكلية", field: "college_name" },
        { label: "الدُفعة", field: "batch_name" },
        { label: "النسبة المئوية", field: "average_pct" },
        { label: "التصنيف", field: "classification" },
        { label: "عمليات", field: "actions" },
      ]
    : [
        { label: "ID", field: "id" },
        { label: "الكود", field: "code" },
        { label: "الاسم", field: "name" },
        { label: "عمليات", field: "actions" },
      ];

  return (
    <div className="mt-3" style={{fontFamily:"Cairo"}}>
      {loading ? (
        <p className="text-center">جاري التحميل...</p>
      ) : noResults ? (
        <p  className="text-center">لا توجد نتائج.</p>
      ) : (
        <>
          <BasisTableComponent 
            data={programs} 
            columns={columns} 
            pagination={pagination}
            onPageChange={handlePageChange} />
        </>
      )}
    </div>
  );
};

export default Programs;
